<template>
  <div id="golf">

    <!-- ======================== 히어로 ======================== -->
    <div class="golf-hero">
      <div class="hero-overlay"></div>
      <div class="hero-pattern"></div>
      <div class="hero-inner">
        <div class="hero-tag">⛳ NTABI GOLF TOUR</div>
        <h1 class="hero-title">일본 골프투어</h1>
        <p class="hero-sub">엄선된 코스에서 펼쳐지는 품격 있는 골프 여행</p>
        <div class="hero-divider">
          <span class="divider-line"></span>
          <i class="bi bi-diamond-fill divider-icon"></i>
          <span class="divider-line"></span>
        </div>
      </div>
      <div class="hero-wave">
        <svg viewBox="0 0 1440 70" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,35 C360,70 720,0 1080,35 C1260,52 1380,28 1440,35 L1440,70 L0,70 Z" fill="#f8f7f2"/>
        </svg>
      </div>
    </div>

    <!-- ======================== 상품 리스트 ======================== -->
    <section class="golf-section">
      <div class="container">

        <div class="golf-item-wrap"
             :key="i"
             v-for="(product, i) in this.productListForSales">

          <!-- 홀수: 이미지 왼쪽 / 짝수: 이미지 오른쪽 -->
          <div class="golf-item" :class="i % 2 === 0 ? 'item-normal' : 'item-reverse'">

            <!-- 이미지 -->
            <div class="golf-img-col"
                 @click="goToDetail(product.pdtCode, product.salesRoute)"
                 style="cursor: pointer">
              <div class="golf-img-wrap">
                <div class="golf-img-hover">
                  <span>자세히 보기</span>
                  <i class="bi bi-arrow-right ms-2"></i>
                </div>
                <img v-if="product.imgName != 'noImage'"
                     :src="`/download/${product.pdtCode}/${product.imgName}`"
                     class="golf-img" alt="..." />
                <img v-else
                     :src="`/download/noImage/noImage.jpg`"
                     class="golf-img" />

                <!-- 넘버링 -->
                <div class="golf-numbering">{{ String(i + 1).padStart(2, '0') }}</div>

                <!-- 뱃지 -->
                <div class="badge-wrap">
                  <div v-if="product.badgeFlag === 'Y'">
                    <div class="badge1"><small class="badge1-text">{{ product.badge }}</small></div>
                  </div>
                  <div v-if="product.badge2Flag === 'Y'">
                    <div v-if="product.badgeFlag != 'Y'" class="badge1">
                      <small class="badge1-text">{{ product.badge2 }}</small>
                    </div>
                    <div v-else class="badge2">
                      <small class="badge2-text">{{ product.badge2 }}</small>
                    </div>
                  </div>
                  <div v-else></div>
                </div>
              </div>
            </div>

            <!-- 텍스트 -->
            <div class="golf-info-col">
              <div class="golf-info-inner">

                <!-- 출발 태그 -->
                <div class="depart-tag" v-if="product.trCd1">
                  <span v-if="product.trCd1 == 'FLT'">
                    <!-- <i class="bi bi-airplane-fill"></i> {{ product.cityName }}출발 항공 -->
                    ⛳ {{ product.cityName }}출발 항공
                  </span>
                  <span v-else-if="product.trCd1 == 'SHP'">
                    ⛳ {{ product.cityName }}출발 선박
                  </span>
                  <span v-else-if="product.trCd1 == 'BUS'">
                    ⛳ 현지출발
                  </span>
                </div>

                <!-- 골프 아이콘 -->
                <!-- <div class="golf-icon-line">
                  <span class="golf-dot"></span>
                  <span class="golf-dot-line"></span>
                  <i class="bi bi-flag-fill golf-flag-icon"></i>
                </div> -->

                <!-- 상품명 -->
                <h4 class="golf-title">{{ product.pdtNameKor }}</h4>

                <!-- 설명 -->
                <p class="golf-remarks">{{ product.pdtRemarks }}</p>

                <!-- 구분선 -->
                <div class="gold-divider"></div>

                <!-- 가격 -->
                <div class="golf-price-area"
                     v-if="product.basic_PdtPrice > 0 && product.displayFlag == 'Y' && product.saleFlag == 'Y'"
                     @click="goToDetail(product.pdtCode, product.salesRoute)"
                     style="cursor: pointer">
                  <!-- 할인 없음 -->
                  <div class="price-wrap" v-if="product.discountPercent == 0">
                    <span class="price-main">{{ getCurrencyFormat(product.pdtPrice) }}</span>
                    <span class="price-won">원</span>
                  </div>
                  <!-- 할인 있음 -->
                  <div class="price-wrap" v-else>
                    <span class="price-original">{{ getCurrencyFormat(product.pdtPrice) }}원</span>
                    <i class="bi bi-caret-right-fill price-arrow"></i>
                    <span class="price-discount">{{ getCurrencyFormat(product.discountPercent) }}%</span>
                    <span class="price-main">{{ getCurrencyFormat((product.basic_PdtPrice*1) + (product.minOptPrice*1)) }}</span>
                    <span class="price-won">원~</span>
                  </div>
                </div>

                <!-- 준비중 -->
                <div class="preparing-wrap" v-else>
                  <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                  <span class="preparing-text">상품을 준비 중입니다</span>
                  <i class="bi bi-question-circle-fill ms-1"
                     style="cursor:pointer; font-size:.9rem; color:#c0a96a"
                     data-bs-toggle="tooltip" data-bs-placement="top"
                     title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"
                     @click="inquiryProduct(product.pdtCode, product.salesRoute)"></i>
                </div>

                <!-- 상세보기 버튼 -->
                <div class="golf-detail-btn"
                     @click="goToDetail(product.pdtCode, product.salesRoute)"
                     style="cursor: pointer">
                  <span>상품보기</span>
                  <i class="bi bi-arrow-right ms-2"></i>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      pdtCatList: [],
      productListForSales: [],
    };
  },
  created() {
    this.getPdtCatList();
    this.getProductList_new();
  },
  mounted() {
    if (this.$store.state.user.handlerId != undefined) {
      document.querySelector(".b2cTag").style.display = "none";
    }
    if (this.$store.state.user.email != undefined) {
      document.querySelector(".b2bTag").style.display = "none";
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    async getPdtCatList()
    {
      let pdtCatList = await this.$api("/api/pdtCatList", {});
      this.pdtCatList = pdtCatList;
    },
    async getProductList_new()
    {
      let productListForSales_tmptmp = await this.$api("/api/productPrcInfo_m_new", {});
      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        return (item.golfFlag === "Y" || (item.pdtCate && item.pdtCate.includes('G')))
      })
      if(productListForSales_tmp.length > 0)
      {
        this.productListForSales = productListForSales_tmp;
      }
    },
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute: salesRoute}});
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&family=Noto+Sans+KR:wght@400;500;600;700&display=swap');

/* ================================================
  # CSS 변수 — 골프 프리미엄 테마
  딥 그린 + 아이보리 + 골드
================================================ */
#golf {
  --golf-green:       #1a3a2a;
  --golf-green-mid:   #2d5a3d;
  --golf-green-light: #3d7a52;
  --golf-green-pale:  #e8f0eb;
  --golf-gold:        #c0a96a;
  --golf-gold-light:  #e8d5a0;
  --golf-gold-dark:   #9a7f45;
  --ivory:            #f8f7f2;
  --ivory-dark:       #f0ede4;
  --charcoal:         #1c1c1c;
  --text-main:        #1c1c1c;
  --text-sub:         #6a6a5a;
  --gray-200:         #e5e4dc;
  --radius-sm:        4px;
  --radius-md:        12px;
  --shadow-sm:        0 2px 12px rgba(26,58,42,0.08);
  --shadow-md:        0 10px 40px rgba(26,58,42,0.16);

  background: var(--ivory);
  font-family: 'Noto Sans KR', sans-serif;
}

@media (min-width: 991px) {
  #golf { margin-top: -6rem; }
}


/* ================================================
  # 히어로
================================================ */
.golf-hero {
  position: relative;
  width: 100%;
  min-height: 28rem;
  background: linear-gradient(135deg, #0d2318 0%, #1a3a2a 45%, #2d5a3d 100%);
  overflow: hidden;
  display: block;
}

/* 격자 패턴 */
.hero-pattern {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(192,169,106,0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(192,169,106,0.08) 1px, transparent 1px);
  background-size: 60px 60px;
  pointer-events: none;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse at 20% 50%, rgba(61,122,82,0.35) 0%, transparent 55%),
    radial-gradient(ellipse at 80% 30%, rgba(192,169,106,0.12) 0%, transparent 45%),
    radial-gradient(ellipse at 50% 100%, rgba(13,35,24,0.5) 0%, transparent 60%);
}
.hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  line-height: 0;
}
.hero-wave svg { display: block; width: 100%; height: 55px; }

.hero-inner {
  position: relative;
  z-index: 1;
  text-align: center;
  width: 100%;
  padding: 6rem 1rem 4rem;
}

.hero-tag {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 4px;
  color: var(--golf-gold-light);
  border: 1px solid rgba(192,169,106,0.4);
  border-radius: 2px;
  padding: 5px 20px;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.hero-title {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 3.2rem;
  font-weight: 400;
  color: #fff;
  letter-spacing: 2px;
  line-height: 1.2;
  margin-bottom: 0.7rem;
  text-shadow: 0 2px 12px rgba(0,0,0,0.3);
}

.hero-sub {
  font-size: 0.95rem;
  color: rgba(255,255,255,0.6);
  letter-spacing: 0.5px;
  margin-bottom: 1.5rem;
}

/* 골드 구분선 */
.hero-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
.divider-line {
  display: block;
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--golf-gold), transparent);
}
.divider-icon {
  font-size: 0.5rem;
  color: var(--golf-gold);
}

@media (max-width: 767px) {
  .golf-hero { min-height: 20rem; }
  .hero-title { font-size: 2.2rem; }
  .hero-inner { padding: 5rem 1rem 3.5rem; }
}


/* ================================================
  # 상품 섹션
================================================ */
.golf-section {
  padding: 5rem 0 8rem;
  background: var(--ivory);
}


/* ================================================
  # 상품 아이템 래퍼
================================================ */
.golf-item-wrap {
  margin-bottom: 6rem;
  position: relative;
}
.golf-item-wrap:last-child { margin-bottom: 0; }

/* 아이템 공통 레이아웃 */
.golf-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  background: #fff;
  border: 1px solid var(--gray-200);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}
.golf-item:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-3px);
}

/* 홀짝 반전 */
.item-normal { direction: ltr; }
.item-reverse { direction: rtl; }
.item-reverse .golf-info-col { direction: ltr; }
.item-reverse .golf-img-col { direction: ltr; }

@media (max-width: 991px) {
  .golf-item {
    grid-template-columns: 1fr;
    direction: ltr !important;
  }
}


/* ================================================
  # 이미지 영역
================================================ */
.golf-img-col {
  position: relative;
  overflow: hidden;
  min-height: 420px;
}
@media (max-width: 991px) {
  .golf-img-col { min-height: 260px; }
}

.golf-img-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.golf-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;
}
.golf-item:hover .golf-img { transform: scale(1.05); }

/* 호버 오버레이 */
.golf-img-hover {
  position: absolute;
  inset: 0;
  background: rgba(26,58,42,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.35s ease;
  z-index: 2;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 1px;
}
.golf-item:hover .golf-img-hover { opacity: 1; }

/* 넘버링 */
.golf-numbering {
  position: absolute;
  bottom: 16px;
  left: 20px;
  font-family: 'Black Han Sans', sans-serif;
  font-size: 5rem;
  font-weight: 400;
  color: rgba(192, 169, 106, 0.541);
  line-height: 1;
  pointer-events: none;
  z-index: 1;
  letter-spacing: -3px;
}

/* 뱃지 */
.badge-wrap { position: absolute; top: 0; left: 0; z-index: 3; }
.badge1 {
  background: rgba(192,169,106,0.9);
  padding: 9px 14px;
  border-radius: 0 0 var(--radius-sm) 0;
}
.badge1-text { color: #fff; font-size: 0.9rem; font-weight: 700; padding: 0; }
.badge2 {
  background: rgba(255,255,255,0.92);
  padding: 9px 14px;
  border-radius: 0 0 var(--radius-sm) 0;
}
.badge2-text { color: var(--golf-green); font-size: 0.9rem; font-weight: 700; padding: 0; }


/* ================================================
  # 텍스트 영역
================================================ */
.golf-info-col {
  display: flex;
  align-items: center;
  background: #fff;
}
.golf-info-inner {
  padding: 3rem 3.5rem;
  width: 100%;
}
@media (max-width: 991px) {
  .golf-info-inner { padding: 2rem 1.8rem; }
}

/* 출발 태그 */
.depart-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--golf-green-light);
  background: var(--golf-green-pale);
  border-radius: 20px;
  padding: 4px 14px;
  margin-bottom: 1.2rem;
}

/* 골프 아이콘 라인 */
.golf-icon-line {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 1rem;
}
.golf-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--golf-gold);
  flex-shrink: 0;
}
.golf-dot-line {
  flex: 1;
  max-width: 40px;
  height: 1px;
  background: var(--golf-gold);
  margin: 0 4px;
}
.golf-flag-icon {
  font-size: 0.75rem;
  color: var(--golf-gold);
}

/* 상품명 */
.golf-title {
  /* font-family: 'Black Han Sans', sans-serif; */
  font-size: 1.6rem;
  font-weight: 800;
  color: var(--golf-green);
  line-height: 1.35;
  margin-bottom: 0.8rem;
  letter-spacing: 0.5px;
}
@media (max-width: 991px) {
  .golf-title { font-size: 1.2rem; }
}

/* 설명 */
.golf-remarks {
  font-size: 0.88rem;
  color: var(--text-sub);
  line-height: 1.7;
  margin-bottom: 0;
  padding-left: 0.8rem;
  border-left: 2px solid var(--golf-gold-light);
}

/* 골드 구분선 */
.gold-divider {
  height: 1px;
  background: linear-gradient(90deg, var(--golf-gold-light), transparent);
  margin: 1.5rem 0;
}

/* 가격 */
.golf-price-area { margin-bottom: 1.8rem; }
.price-wrap {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px;
}
.price-main {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--golf-green);
  letter-spacing: -0.5px;
  line-height: 1;
}
.price-won {
  font-size: 1rem;
  color: var(--text-sub);
  font-weight: 500;
}
.price-original {
  font-size: 0.88rem;
  color: var(--text-sub);
  text-decoration: line-through;
}
.price-arrow {
  font-size: 0.75rem;
  color: var(--text-sub);
}
.price-discount {
  font-size: 1rem;
  font-weight: 800;
  color: var(--golf-gold-dark);
}
.preparing-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 1.8rem;
}
.preparing-text { font-size: 0.9rem; color: var(--text-sub); font-weight: 600; }
.mbus-icon { width: 2rem !important; height: auto !important; }

/* 상세보기 버튼 */
.golf-detail-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 28px;
  background: var(--golf-green);
  color: var(--golf-gold-light);
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 2px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(26,58,42,0.2);
}
.golf-detail-btn:hover {
  background: var(--golf-gold);
  color: var(--golf-green);
  box-shadow: 0 6px 20px rgba(192,169,106,0.35);
}
</style>